"use client";

import { LoaderCircle } from "lucide-react";
import { useTranslations } from "next-intl";

export function ParsingStep({ restoring }: { restoring: boolean }) {
  const t = useTranslations("profile.resumePersonalization");

  return (
    <div className="flex min-h-56 flex-col items-center justify-center gap-4 text-center">
      <LoaderCircle className="h-10 w-10 animate-spin" />
      <div>
        <p className="font-bold">
          {restoring ? t("parsing.loadingTitle") : t("parsing.readingTitle")}
        </p>
        <p className="mt-1 text-sm text-[#667085]">
          {restoring
            ? t("parsing.loadingDescription")
            : t("parsing.readingDescription")}
        </p>
      </div>
    </div>
  );
}
